export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Website"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop-ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop-Einstellungen"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zahlungslink"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiv"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicht aktiv"])}
}